import React, { useState, useEffect } from "react";
import { getDocs, collection ,doc,deleteDoc} from "firebase/firestore";
import { Link } from "react-router-dom";
import { db, auth } from "../../firebase";
export default function Showjob() {
  const [joblist, setJoblist] = useState([]);
  const ref = collection(db, `Industry/${auth.currentUser.uid}/more-details`);
  useEffect(() => {
    const getjob = async () => {
      const data = await getDocs(ref);
      setJoblist(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getjob();
  },[]);
  const getjob = async () => {
    const data = await getDocs(ref);
    setJoblist(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };
  const deleteHandler=async(id)=>{
    // await bookServices.deleteBook(id);
    const jobDoc =  doc(db,`Industry/${auth.currentUser.uid}/more-details`,id);
    getjob();
    return deleteDoc(jobDoc);
    
}


  return (
    <>
    <div className="mainn">
     <div className="recipes">
       
    {joblist.map((post) => {
        return (
          <div className="recipe">   
            <div className="position">Position : {post.position} </div>
            <hr/>
            <div className="preedit"><span className="postedit">Requirements : </span> {post.requirment} </div>
            <div className="preedit"><span className="postedit">Salary : </span>{post.salary} </div>
            <div className="preedit"><span className="postedit">Vacancy :  </span>{post.vacancy} </div>
            <div className="preedit"><span className="postedit">Job posted on :  </span>{post.postedon} </div>
            <div className="preedit"><span className="postedit">Last Date to apply :  </span>{post.lastdate} </div>
            
            {/* <button className="bg-danger" onClick={(e) => deleteHandler(post.id)}>Delete Job</button>
            <button className="bg-primary">Applied by</button> */}
            <div className="buttons">
            <button className="bg-danger btnpost" onClick={(e) => deleteHandler(post.id)}>Delete Job</button>
            
            <Link className="bg-primary btnpost" to="/displayapplied" state={{ pos: post.postid }}> Applied by</Link>

          </div>
            
          </div>
        );
      })}
    </div>
    </div>
    </>
  );
}


// const [clicked,setClicked] = useState(false);
//   const menuList = MenuList.map(({ url, title }, index) => {
//     return (
//       <li key={index}>
//         <Link to={url} activeClassName="active">
//           {title}
//         </Link>
//       </li>
//     );
//   });
//   const handleClick = () => {
//     setClicked(!clicked);
//   };
//   return (
//     <nav className="flex items-center bg-black p-3 flex-wrap navbar-nav">
//       <Link to="/" className="h-13 w-20 p-2 ml-8 mr-4 inline-flex items-center">
//         <img
//           src="https://www.pictcsi.com/assets/CSI%20Logo%20Nav.png"
//           alt="PCSB"
    
//         ></img>
//       </Link>
//       <div className="menu-icon" onClick={handleClick}>
//       <i className={clicked ? "fas fa-times" : "fas fa-bars"}></i>
//       </div>
//       <ul className={clicked ? "menu-list" : "menu-list close"}>
//         {menuList}
//       </ul>
//     </nav>
//   );
// }